import React from "react";

function Account() {
  return (
    <div style={{color:"red"}}>
      <h1>I am in Accounts Section</h1>
      <h2>You are having balance of Rs. 200000/-</h2>
    </div>
  );
}

export default Account;
